import moment from 'moment'

export default {
  computed: {
    // Return all periods
    period_list: function() {
      return [
        { text: 'Ultimi 30 gg', value: '30d' },
        { text: 'Ultimi 60 gg', value: '60d' },
        { text: 'Ultimi 90 gg', value: '90d' },
        { text: 'Mese corrente', value: '0M' },
        { text: 'Mese scorso', value: '1M' },
        { text: 'Settimana corrente', value: '0w' },
        { text: 'Settimana scorsa', value: '1w' },
      ];
    },
  },

  methods: {
    // Convert given period into from and to date
    period_toDateInterval: function(period) {
      let dateFrom;
      let dateTo = moment().locale('it', { week: {
        dow: 1, // First day of week is Monday
        doy: 7  // First week of year must contain 1 January (7 + 1 - 1)
      }});

      switch (period) {
        case '30d':
          dateFrom = moment(dateTo).subtract(30, 'd');
          break;
        case '60d':
          dateFrom = moment(dateTo).subtract(60, 'd');
          break;
        case '90d':
          dateFrom = moment(dateTo).subtract(90, 'd');
          break;
        case '0M':
          dateTo.endOf('month');
          dateFrom = moment(dateTo).startOf('month');
          break;
        case '1M':
          dateTo.subtract(1, 'M').endOf('month');
          dateFrom = moment(dateTo).startOf('month');
          break;
        case '0w':
          dateTo.endOf('week');
          dateFrom = moment(dateTo).startOf('week');
          break;
        case '1w':
          dateTo.subtract(1, 'w').endOf('week');
          dateFrom = moment(dateTo).startOf('week');
          break;
      }

      return (dateFrom) ? [
        dateFrom.format('YYYY-MM-DD'),
        dateTo.format('YYYY-MM-DD 23:59:59')
      ] : null;
    },
  }
}
